import {toFarsiNumber} from "../../cudtom-hooks/en-to-persian";

const ReportsBoxColumn = ({firstRowReport, waterType, data}) => {
    let defaultCount = toFarsiNumber(0)
    return(
        <div className='column'>
            <div>
                <span>{firstRowReport}</span>
                <span>{data ? data[0] : defaultCount}</span>
            </div>
            <div>
                <span>درخواست های {waterType} تحویل شده:</span>
                <span>{data ? data[1] : defaultCount}</span>
            </div>
            <div>
                <span>حجم {waterType} درخواست شده:</span>
                <span><span>{data ? data[2] : defaultCount} </span><span>لیتر</span></span>
            </div>
            <div>
                <span>حجم {waterType} تحویل شده:</span>
                <span><span>{data ? data[3] : defaultCount} </span><span>لیتر</span></span>
            </div>
            <div>
                <span>درخواست {waterType} رد شده:</span>
                <span><span>{data ? data[4] : defaultCount} </span><span>درخواست</span></span>
            </div>
        </div>
    )
}

export default ReportsBoxColumn